// Platform defaults for vehicle-status thresholds. Per-org overrides live at
// organizations.settings.statusThresholds and are merged by useStatusThresholds().
//
// - staleMinutes: how long without a GPS fix before a device is treated as offline.
// - idleSeconds: (reserved) how long ignition can be ON with speed 0 before "idle".
// - movingSpeedKmh: speed below this is treated as stopped, not moving — avoids
//   GPS-jitter ("Teltonika stationary glitch") flipping a parked car to moving.
// - jitterSpeedKmh: when ignition=false AND speed is below this, treat the fix as
//   GPS chatter on a parked vehicle. Suppresses the speed/heading values on the
//   Live Map, freezes the animated marker, and stops the trail from zigzagging.
// - movingStaleSeconds: tighter staleness gate for vehicles that were last seen
//   moving. A 79 km/h reading from 7 min ago is much less credible than a
//   "parked" reading from 7 min ago — reclassify to pending so operators don't
//   trust the stale speed/heading. Stationary classifications keep the broader
//   staleMinutes threshold.
export const DEFAULT_STATUS_THRESHOLDS = Object.freeze({
  staleMinutes: 10,
  idleSeconds: 300,
  movingSpeedKmh: 3,
  jitterSpeedKmh: 10,
  movingStaleSeconds: 180,
});

export function mergeStatusThresholds(override) {
  if (!override || typeof override !== 'object') return { ...DEFAULT_STATUS_THRESHOLDS };
  const n = (v, fallback) => {
    const num = Number(v);
    return Number.isFinite(num) && num >= 0 ? num : fallback;
  };
  return {
    staleMinutes: n(override.staleMinutes, DEFAULT_STATUS_THRESHOLDS.staleMinutes),
    idleSeconds: n(override.idleSeconds, DEFAULT_STATUS_THRESHOLDS.idleSeconds),
    movingSpeedKmh: n(override.movingSpeedKmh, DEFAULT_STATUS_THRESHOLDS.movingSpeedKmh),
    jitterSpeedKmh: n(override.jitterSpeedKmh, DEFAULT_STATUS_THRESHOLDS.jitterSpeedKmh),
    movingStaleSeconds: n(override.movingStaleSeconds, DEFAULT_STATUS_THRESHOLDS.movingStaleSeconds),
  };
}
